import "./ActionBar.scss"
import React, { useEffect, useState } from "react"
import { Button, DropDownButton } from "devextreme-react"
import { Col } from "../layout/grid/Col"

interface ActionButton {
    text: string
    icon?: string
    onClick: () => void
    disabled?: boolean
    stylingMode?: "contained" | "outlined" | "text"
    type?: "default" | "success" | "danger"
    position?: "left" | "right"
}

interface ActionBarProps {
    buttons?: ActionButton[]
    children?: React.ReactNode
    className?: string
}

const ActionBar: React.FC<ActionBarProps> = ({ buttons, children, className }) => {
    const [isScrolled, setIsScrolled] = useState(false)

    let leftContent: React.ReactNode[] = []
    let rightContent: React.ReactNode[] = []

    useEffect(() => {
        const scrollableElement = document.querySelector('.content')

        if (!scrollableElement) return

        const handleScroll = () => {
            const scrolled = scrollableElement.scrollTop > 10
            setIsScrolled(scrolled)
        }


        scrollableElement.addEventListener('scroll', handleScroll)
        return () => scrollableElement.removeEventListener('scroll', handleScroll)
    }, [])

    buttons?.forEach((button, index) => {
        const buttonElement = (
            <Button
                key={`button-${index}`}
                className={`dx-button border-radius-xsmall action-bar-item shadow ${className ? className : ''}`}
                stylingMode={button.stylingMode}
                type={button.type || "default"}
                onClick={button.onClick}
                disabled={button.disabled}
                icon={button.icon ? `dx-icon dx-icon-${button.icon}` : undefined}
                text={button.text} />)

        if (button?.position === "right") {
            rightContent.push(buttonElement)
        } else {
            leftContent.push(buttonElement)
        }
    })

    React.Children.forEach(children, (child) => {
        if (React.isValidElement(child)) {
            if (child.type === Left) {
                leftContent = child.props.children
            } else if (child.type === Right) {
                rightContent = child.props.children
            }
        }
    })

    return (
        <div className={`action-bar m-05 ${isScrolled ? 'scrolled' : ''} ${className ? className : ''}`}>
            <div className="action-bar-inline">
                <div className="action-bar-left">
                    {leftContent}
                </div>
                <div className="action-bar-right">
                    {rightContent}
                </div>
            </div>
        </div>

    )
}

export const Left: React.FC<{ children: React.ReactNode }> = ({ children }) => <>{children}</>
export const Right: React.FC<{ children: React.ReactNode }> = ({ children }) => <>{children}</>

export default ActionBar
